<template>
  <div>
    <div class="top-bar">
        <img :src="imgheader" alt="Mario Machuca Sitio Oficial">
    </div>
    <nav v-bind:class="isScrolling ? 'navbar is-danger is-fixed-top' : 'navbar is-danger'" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">

        <a class="navbar-burger" data-target="navMenu" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navMenu" class="navbar-menu" v-bind:class="{ 'is-active': showNav  }">
        <div class="navbar-start">

          <router-link to="/" class="navbar-item">Inicio</router-link>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              CROC
            </a>
            <div class="navbar-dropdown">
              <router-link :to="{name:'Croc'}" class="navbar-item">Acerca de</router-link>
              <router-link :to="{name:'Conocenos'}" class="navbar-item">Conócenos</router-link>
            </div>
          </div>
          <a class="navbar-item" href="http://www.radiocroc.com">Radio</a>
          <router-link :to="{name:'Programas'}" class="navbar-item">Programas Sociales</router-link>
          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              Informes
            </a>
            <div class="navbar-dropdown">
              <router-link :to="{name:'Informe'}" class="navbar-item">Informe CROC</router-link>
            </div>
          </div>
          <router-link :to="{name:'Videos'}" class="navbar-item">Videos</router-link>
          <router-link :to="{name:'Noticias'}" class="navbar-item">Noticias</router-link>
          <router-link :to="{name:'Vacantes'}" class="navbar-item">Vacantes</router-link>
          <router-link :to="{name:'Convenios'}" class="navbar-item">Convenios Croc</router-link>
          <router-link :to="{name:'Contacto'}" class="navbar-item">Contacto</router-link>

        </div>

      </div>
    </nav>
  </div>
</template>

<script>
import headerimg from '@/assets/img/banercroc.png'

export default {
  data () {
    return {
      imgheader:headerimg,
      showNav: false,
      isScrolling:false,
    }
  },
  methods:{
    handleScroll () {
      this.isScrolling = window.scrollY > 100 ? true: false;
    }
  },
  created :function(){
    window.addEventListener('scroll', this.handleScroll);
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue